import { Button, Dropdown, Menu } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { faBrowser } from '@fortawesome/pro-duotone-svg-icons'
import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
import { getSidebarTabs } from 'api/product-menu/getSidebarTabs'
import styles from './ProductDropdown.module.scss'

const ProductDropdown: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const [tabs, setTabs] = useState<any>()

  useEffect(() => {
    getSidebarTabs()
      .then((data) => {
        setTabs(Object.values(data).flat())
      })
      .catch(() => {
        setTabs([])
      })
  }, [])

  const handleNavigation = (url: string) => {
    if (url.includes('http')) {
      window.open(url, '_self')?.focus()
      return
    }
    history.replace(url)
  }

  const menu = (
    <Menu className={styles.dropdownMenu}>
      <Menu.Item
        className={styles.item}
        onClick={() =>
          handleNavigation(`${process.env.REACT_APP_APP_URL}/#/v2/home`)
        }
        key="home"
      >
        <span className={styles.icon}>
          {' '}
          <FontAwesomeIcon icon={faBrowser} />
        </span>
        <span className={styles.text}>{t('rankmiProducts.start.title')}</span>
      </Menu.Item>
      {tabs?.map((tab: any) => {
        return (
          <Menu.Item
            className={styles.item}
            onClick={() => handleNavigation(tab.url)}
            key={tab.id}
          >
            {tab.icon ? (
              <span className={styles.icon}>
                <FontAwesomeIcon icon={tab.icon} />
              </span>
            ) : (
              <img
                className={styles.iconImage}
                src={tab.image}
                alt={`icon ${tab.translation}`}
              />
            )}
            <span className={styles.text}>{t(tab.translation)}</span>
          </Menu.Item>
        )
      })}
    </Menu>
  )

  return (
    <Dropdown
      overlay={menu}
      overlayClassName={styles.overlay}
      trigger={['click']}
    >
      <Button className={styles.dropdown}>
        {t('rankmiProducts.lms.title')}
        <FontAwesomeIcon className={styles.chevron} icon={faChevronDown} />
      </Button>
    </Dropdown>
  )
}

export default ProductDropdown
